const getters = {
  statuses:           state => state.statuses,
  statusById:         state => id => {
    let status = Object.values(state.statuses).find(status => status.id === id);
    return status ? status : { name: 'Не известно', icon: 'MehIcon', color: '' };
  },
  priorityById:       state => id => {
    let priority = Object.values(state.priorities).find(priority => priority.id === id);
    return priority ? priority : { name: 'Не известно', icon: 'MehIcon', color: '' };
  },
  categories:         state => state.categories,
  newCategories:      state => state.newCategories,
  categoryById:       state => id => {
    let category = Object.values(state.categories).concat(Object.values(state.newCategories)).find(category => category.id === id);
    return category ? category : { name: 'Не известно', icon: 'MehIcon', color: '' };
  },
  unreadMessages:     state => state.unreadMessages,
  unreadMessagesById: state => id => state.unreadMessages[id] || 0,

  unreadByStatusId: state => statusId => state.unreadByStatuses[statusId] || 0,

  // unreadByCategoryId:    state => ( categoryId, statusIds ) => {
  //   const categoryUnread = state.unreadByCategories[categoryId];
  //   if (!categoryUnread) return 0;
  //
  //   if (!statusIds || !statusIds.length) {
  //     let total = 0;
  //     for (let statusId in categoryUnread) {
  //       total += categoryUnread[statusId] || 0;
  //     }
  //     return total;
  //   }
  //
  //   return statusIds.reduce(( total, statusId ) => {
  //     return total + (categoryUnread[statusId] || 0);
  //   }, 0);
  // },
  // unreadByAllCategories: ( state, getters ) => ( statusIds ) => {
  //   let total = 0;
  //   for (let categoryId in state.unreadByCategories) {
  //     total += getters['unreadByCategoryId'](categoryId, statusIds);
  //   }
  //   return total;
  // },

  unreadMessagesTotal: state => state.unreadMessagesTotal,
  sortTypes:           state => state.sortTypes,
};

export default getters;
